import { render, staticRenderFns } from "./MenuAcademy.vue?vue&type=template&id=b43b532c&scoped=true&"
import script from "./MenuAcademy.vue?vue&type=script&lang=js&"
export * from "./MenuAcademy.vue?vue&type=script&lang=js&"
import style0 from "./MenuAcademy.vue?vue&type=style&index=0&id=b43b532c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43b532c",
  null
  
)

export default component.exports